import { currencyInput, defaultBooleanValue } from '@/_schemas/generic';
import { defaultNumericIdOption } from '@/_shared';

import { defaultClientOpt, type DeliverablesFormSchema } from './schemas';

const price_frequency = defaultNumericIdOption();
export const defaultValues: Readonly<DeliverablesFormSchema> = {
  id: -1,
  quantity: '1',
  price: currencyInput.defaultValue(),
  product_name: '',
  client_opt: defaultClientOpt,
  price_frequency,
  product: null,
  agreement_id: -1,
  sku: '',
  sort_order: -1,
  opted_in: defaultBooleanValue(),
  opted_out: defaultBooleanValue(),
  deliverable_wholesale_price: [],
  description: '',
} as const;
